export default {
  filterSearchPlaceholder: 'Search Experiments...',
  noExperiments: `There are no experiments with the selected filter(s)`,
  noSearchResults: searchValue => ` No experiments match "${searchValue}"`,
}
